
export type NonEmptyArray<T> = T extends readonly [unknown, ...unknown[]] ? T : never;

export function isNotNullOrEmpty<T extends readonly unknown[] | []>(arr: T | null): arr is NonEmptyArray<{ [P in keyof T]: T[P] }> {
  if(arr == null) return false;
  return arr.length > 0;
}

export function isNullOrEmpty<T extends readonly unknown[] | []>(arr: T | null): boolean {
  return arr == null || arr.length <= 0;
}

export function isNotEmpty<T extends readonly unknown[] | []>(arr: T): arr is NonEmptyArray<{ [P in keyof T]: T[P] }> {
  return arr.length > 0;
}

export function isEmpty<T extends readonly unknown[] | []>(arr: T): boolean {
  return arr.length <= 0;
}

